export enum FileLocationEnum {
    Logbog = 1,
    Stamdata = 2,
    Email = 3
}
